import { SurfaceConstants } from 'owa-calendar-surface-core';
import { getNumColumns } from './getNumColumns';

export default function isManyDayView() {
    return getNumColumns() >= SurfaceConstants.numColumnsToShowDynamicColumns;
}
